import { Heart, Sparkles, Flame, Moon, Shield, Eye, MessageCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';

const SERVICE_ICONS = { Heart, Sparkles, Flame, Moon, Shield, Eye };

export const ServiceCard = ({ service, handleWhatsAppClick }) => {
const IconComponent = SERVICE_ICONS[service.icon] || Sparkles;
return (
<Card data-testid={`service-card-${service.id}`} className="service-card bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-red-900/40 hover:border-red-600/70 transition-all duration-500 transform hover:scale-105 hover:shadow-2xl hover:shadow-red-600/30">
                  <CardHeader>
                    <div className="relative mb-4">
                      <div className="w-20 h-20 bg-gradient-to-br from-red-600 via-red-700 to-red-800 rounded-2xl flex items-center justify-center mx-auto shadow-lg shadow-red-600/50">
                        <IconComponent className="w-10 h-10 text-white" />
                      </div>
                      <div className="absolute inset-0 blur-2xl bg-red-600 opacity-20 rounded-2xl"></div>
                    </div>
                    <CardTitle className="text-2xl text-red-500 text-center leading-tight mb-3">{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-300 leading-relaxed text-sm mb-6">{service.description}</p>
                    {service.id === 1 && (
                      <Link data-testid="retour-affectif-service-link" to="/retour-affectif-guadeloupe" className="inline-block text-yellow-400 hover:text-yellow-300 underline underline-offset-4 mb-4 transition-colors">
                        Retour affectif en Guadeloupe
                      </Link>
                    )}
                    {[6, 7].includes(service.id) && (
                      <Link data-testid={`service-page-link-${service.id}`} to={service.id === 6 ? '/desenvoutement-guadeloupe' : '/voyance-guadeloupe'} className="inline-block text-yellow-400 hover:text-yellow-300 underline underline-offset-4 mb-4 transition-colors">
                        {service.id === 6 ? 'Désenvoûtement en Guadeloupe' : 'Voyance en Guadeloupe'}
                      </Link>
                    )}
                    <Button 
                      data-testid={`service-whatsapp-button-${service.id}`}
                      onClick={handleWhatsAppClick}
                      className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white transition-all duration-300 font-semibold shadow-lg shadow-green-500/30"
                    >
                      <MessageCircle className="w-4 h-4 mr-2" />
                      Consulter sur WhatsApp
                    </Button>
                  </CardContent>
                </Card>
);
};
